const statuses = [
  { value: 'Active', name: 'Active' },
  { value: 'Inactive', name: 'Inactive' },
];
export default statuses;
